var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M80 16c35.29 0 64 28.71 64 64s-28.71 64-64 64-64-28.71-64-64 28.71-64 64-64m0-16C35.82 0 0 35.82 0 80s35.82 80 80 80 80-35.82 80-80S124.18 0 80 0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m91.31 80 18.38-18.38c3.12-3.12 3.12-8.19 0-11.31s-8.19-3.12-11.31 0L80 68.69 61.62 50.31c-3.12-3.12-8.19-3.12-11.31 0-3.12 3.12-3.12 8.19 0 11.31L68.69 80 50.31 98.38c-3.12 3.12-3.12 8.19 0 11.31 3.12 3.12 8.19 3.12 11.31 0L80 91.31l18.38 18.38c3.12 3.12 8.19 3.12 11.31 0 3.12-3.12 3.12-8.19 0-11.31L91.31 80Z"
}))));

export default SvgError;